import { render, staticRenderFns } from "./dados.vue?vue&type=template&id=4d7bdfd2&"
import script from "./dados.vue?vue&type=script&lang=js&"
export * from "./dados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports